module.exports = "//public.getcloudapp.com/packs/media/images/annotate/pixelate-ae56806a094433fd2073f42934f19fc7.svg";